import { render } from "./SideMenu.vue?vue&type=template&id=62db6384&scoped=true&ts=true"
import script from "./SideMenu.vue?vue&type=script&lang=ts"
export * from "./SideMenu.vue?vue&type=script&lang=ts"

import "./SideMenu.vue?vue&type=style&index=0&id=62db6384&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62db6384"]])

export default __exports__